import { Auth as AmplifyAuth } from "aws-amplify";

import { authClient } from "./client";
import type { AuthConfig, LoginSession } from "./types";

export function Auth(config: AuthConfig) {
  AmplifyAuth.configure({ Auth: config });

  let loginSession: LoginSession | undefined;

  const client = authClient(AmplifyAuth);

  return {
    ...client,
    login: async (email: string) => {
      loginSession = await client.login(email);
    },
    sendLoginChallenge: async (code: string) => {
      if (!loginSession) {
        throw new Error("No login session");
      }

      await client.sendLoginChallenge(loginSession, code);
      loginSession = void 0;
    },
  };
}

export type AuthClient = ReturnType<typeof Auth>;
